const GOOGLE_SHEET_TOOLS = ['spreadsheets_tabs', 'spreadsheets_describe', 'spreadsheets_search'];

export function isGoogleSheetTool(provider: string, tool?: string): boolean {
  return provider.toLowerCase() === 'google' && !!tool && GOOGLE_SHEET_TOOLS.includes(tool);
}
